import { showSnackbar, setLoading } from 'reducers/ui';
import { errorHandler } from 'utils/errorMessages';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { getSystemTimeZone, getTimezone } from 'reducers/utils';
import API from 'services/api';
import get from 'lodash/get';
import {
  visitorActions,
  visitorFilterActions,
  visitorPageActions,
  visitorSelectors,
} from 'containers/Pages/Locations/Visitors';
import {
  getRegionId,
  getSecurityId,
  getUserSelectedLanguage,
} from 'reducers/users';

export function* fetchVisitListSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const timezone = yield select(getSystemTimeZone);
    const { filters, from } = payload;
    const { data } = yield call(API.getVisitList, {
      ...filters,
      timezone,
      from,
    });

    if (data.data) {
      const totalEntries = get(data, 'meta.total');
      yield put(visitorActions.setGridList({ list: data.data, totalEntries }));
    }
    yield put(visitorFilterActions.setFilterKey(false));
    yield put(visitorActions.setForceRefresh(false));
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* fetchVisitDetailsSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { id } = payload;
    //select from the state
    const rows = yield select(visitorSelectors.getVisitorListRaw);
    const value = rows.find(f => f.id === id);
    if (value) {
      yield put(visitorActions.setGridRowDetails({ details: value }));
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* printVisitListSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { filters } = payload;
    const timezone = yield select(getTimezone);
    const regionId = yield select(getRegionId);
    const securityCompanyId = yield select(getSecurityId);
    const language = yield select(getUserSelectedLanguage);
    const { data } = yield call(API.fetchVisitListPdf, {
      regionId,
      securityCompanyId,
      timezone,
      language: language.toUpperCase(),
      ...filters,
    });
    if (data.data) {
      const { url } = data.data;
      window.open(url, '_blank');
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* printVisitDetailsSaga({ payload }) {
  try {
    const { id } = payload;
    yield put(setLoading(true));
    const timezone = yield select(getTimezone);
    const language = yield select(getUserSelectedLanguage);
    const { data } = yield call(API.fetchVisitDetailsPdf, {
      id,
      timezone,
      language: language.toUpperCase(),
    });
    if (data.data) {
      const { url } = data.data;
      window.open(url, '_blank');
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* signOutVisitorSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { id, details } = payload;
    const {
      visitor,
      passId,
      accessTime,
      siteId,
      siteName,
      egressTime,
    } = details;
    const { data } = yield call(API.logoutVisitor, {
      id,
      visitor,
      passId,
      accessTime,
      egressTime,
      siteId,
      siteName,
    });
    const { firstName, lastName } = visitor;
    if (data) {
      yield put(
        showSnackbar({
          typeOfSnackbar: 'success',
          message: `${firstName} ${lastName} signed out`,
        }),
      );
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* visitorSagas() {
  yield takeLatest(visitorActions.fetchGridList, fetchVisitListSaga);
  yield takeLatest(visitorActions.fetchGridRowDetails, fetchVisitDetailsSaga);
  yield takeLatest(visitorPageActions.printVisitorList, printVisitListSaga);
  yield takeLatest(
    visitorPageActions.printVisitorDetails,
    printVisitDetailsSaga,
  );
  yield takeLatest(visitorPageActions.signOutVisitor, signOutVisitorSaga);
}
